import React from 'react';
import { connect } from 'react-redux';
import './LineCursor.css';

const LineCursor = props => {
  const { screenX, timeLabel, width, height, sceneVideo, hoveredSpot } = props;
  return (
    <div
      id="line-cursor"
      className={
        sceneVideo.length === 0 &&
        ((hoveredSpot !== 0 && hoveredSpot !== 1) || height > 840)
          ? 'active'
          : ''
      }
      style={{
        left: `${screenX}px`,
      }}
    >
      <div id="line-label" className={width - screenX < 70 ? 'right' : 'left'}>
        {timeLabel}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  width: state.ui.width,
  height: state.ui.height,
  sceneVideo: state.app.sceneVideo,
  hoveredSpot: state.app.hoveredSpot,
});

export default connect(mapStateToProps)(LineCursor);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/LineCursor/LineCursor.js